import Api from '../utils/Api';
import Auth from '../services/Auth';
import { createNotification } from './notifications';

export const CREATE_SESSION_REQUEST = 'CREATE_SESSION_REQUEST';
export const CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS';
export const CREATE_SESSION_FAILURE = 'CREATE_SESSION_FAILURE';

export const UPDATE_SESSION_REQUEST = 'UPDATE_SESSION_REQUEST';
export const UPDATE_SESSION_SUCCESS = 'UPDATE_SESSION_SUCCESS';
export const UPDATE_SESSION_FAILURE = 'UPDATE_SESSION_FAILURE';

export const DELETE_SESSION_REQUEST = 'DELETE_SESSION_REQUEST';
export const DELETE_SESSION_SUCCESS = 'DELETE_SESSION_SUCCESS';
export const DELETE_SESSION_FAILURE = 'DELETE_SESSION_FAILURE';

export const FETCH_SESSION_REQUEST = 'FETCH_SESSION_REQUEST';
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS';
export const FETCH_SESSION_FAILURE = 'FETCH_SESSION_FAILURE';

const createSessionRequest = () => ({
  type: CREATE_SESSION_REQUEST
});

const createSessionSuccess = data => dispatch => {
  const messages = [{ text: 'Welcome to the party.', type: 'success' }];
  dispatch(createNotification(messages));
  dispatch({
    type: CREATE_SESSION_SUCCESS,
    user: data.user
  });
};

const createSessionFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: CREATE_SESSION_FAILURE
    };
  });
};

export const createSession = params => dispatch => {
  dispatch(createSessionRequest());
  return Api.createSession(params)
    .then(data => dispatch(createSessionSuccess(data)))
    .catch(error => dispatch(createSessionFailure(error)));
};

const updateSessionRequest = () => ({
  type: UPDATE_SESSION_REQUEST
});

const updateSessionSuccess = data => ({
  type: UPDATE_SESSION_SUCCESS,
  user: data
});

const updateSessionFailure = () => ({
  type: UPDATE_SESSION_FAILURE
});

export const updateSession = params => dispatch => {
  dispatch(updateSessionRequest());
  if (Auth.isAuthenticated()) {
    dispatch(updateSessionSuccess(params));
  } else {
    dispatch(updateSessionFailure());
  }
};

const deleteSessionRequest = () => ({
  type: DELETE_SESSION_REQUEST
});

const deleteSessionSuccess = () => ({
  type: DELETE_SESSION_SUCCESS
});

const deleteSessionFailure = () => ({
  type: DELETE_SESSION_FAILURE
});

export const deleteSession = () => dispatch => {
  dispatch(deleteSessionRequest());
  if (Auth.isAuthenticated()) {
    Auth.logout();
    dispatch(deleteSessionSuccess());
  } else {
    dispatch(deleteSessionFailure());
  }
};

const fetchSessionRequest = () => ({
  type: FETCH_SESSION_REQUEST
});

const fetchSessionSuccess = data => ({
  type: FETCH_SESSION_SUCCESS,
  user: data
});

const fetchSessionFailure = () => ({
  type: FETCH_SESSION_FAILURE
});

export const fetchSession = () => dispatch => {
  dispatch(fetchSessionRequest());
  return Api.getSession()
    .then(data => dispatch(fetchSessionSuccess(data)))
    .catch(error => dispatch(fetchSessionFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/sessions.js